import { useQuery } from "react-query";
import axios from "axios";

const getPortfolioInvitesForPortfolio = async ({ portfolioId }) => {
  let url = `/api/v2/portfolios/${portfolioId}/invites`;

  const { data: portfolioInvites } = await axios.get(url);
  return portfolioInvites;
};
export default function usePortfolioInvitesForPortfolio({
  portfolioId,
  refetchOnMount = false,
}) {
  return useQuery(
    ["portfolios", portfolioId, "invites"],
    () => {
      return getPortfolioInvitesForPortfolio({ portfolioId });
    },
    { refetchOnMount: refetchOnMount, enabled: !!portfolioId }
  );
}
